import SkipLink from '@/components/SkipLink'

export default memo(function SkipLinks() {
  return (
    <>
      <SkipLink title='Skip to navigation' to='#navigation' />
      <SkipLink title='Skip to message form' to='#message-form' />
      <SkipLink title='Skip to conversation content' to='#conversation-content' />
    </>
  )
})
